export const ptBR = {
    time_limit_access_exceeded_contact_responsible:
        'Foi excedido o limite de tempo para acessar a página, contate o responsável para gerar um novo link caso necessário',
    url_not_found: 'URL não encontrada',
    ensure_url_entered_is_correct_with_responsible: 'Certifique-se que a URL digitada está correta com o responsável.',
    temporary_link_expired: 'Link Temporário expirado',
};
